// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1DFhI","balanceDisclaimer":"posDashboard_balanceDisclaimer__8SNfZ"};